import React, { useEffect } from 'react';
import { getTotalSales } from '../../slices/dashboard';
import { useSelector, useDispatch } from 'react-redux'
import { Card } from '.';
import { formatMoney, formatPercentage } from '../../utils';

export const TotalSalesComparison = () => {

    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getTotalSales())
    }, [])

    const totalSales = useSelector((state) => state.dashboard.totalSales?.total_sales);
    const totalSalesPrevious = useSelector((state) => state.dashboard.totalSales?.total_sales_previous);
    const totalSalesLoading = useSelector((state) => state.dashboard.totalSalesLoading || false);
    const change = (totalSales - totalSalesPrevious) / totalSalesPrevious * 100;
    const sign = change > 0 ? '+' : '-';

    return (<>
        {totalSalesLoading === true ?
            <div className="loader top-50 start-50 position-absolute" role="status"></div>
            :
            <>
                <div className='mb-3 mb-xl-5 order-4 order-xl-1 d-flex d-xl-block legend-container'>
                    <div className='legend mb-3 me-5 me-xl-0 d-flex align-items-center'><span className='d-block me-2 bluegreen'></span>{gettext('Last 12 months')}</div>
                    {totalSalesPrevious > 0 && <div className='legend mb-3 d-flex align-items-center'><span className='d-block me-2 grey'></span>{gettext('Year before')}</div>}
                </div>
                <div className='underline me-xl-0 side'>
                    <span>{gettext('Total Sales last 12 months')}</span>
                    <div className='large'>{formatMoney(totalSales)} <span>kr.</span></div>
                </div>
                {totalSalesPrevious > 0 &&
                    <>
                        <div className='mb-5 me-xl-0 side'>
                            <span>{gettext('Total Sales previous period')}</span>
                            <div className='large'>{formatMoney(totalSalesPrevious)} <span>kr.</span></div>
                        </div>
                        <div className='mb-4'>
                            <span>{gettext('Change between periods')}</span>
                            <div className='large'>{sign}{formatPercentage(Math.abs(change), 0, '')}<span>%</span></div>
                        </div>
                    </>
                }
            </>
        }
    </>);
};